import { useTranslation } from 'react-i18next';
import { X } from '@sib/ui/icons';
import { FileManager } from './FileManager';

interface FileManagerContentProps {
  closeDialog: () => void;
}

export const FileManagerContent = ({
  closeDialog,
}: FileManagerContentProps) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="flex">
        <p className="text-primary my-auto w-full justify-center text-center text-xl font-semibold">
          {t('fileManager.uploadFiles')}
        </p>
        <button
          onClick={closeDialog}
          className="cursor-pointer"
          aria-label="Close"
        >
          <X className="text-primary h-[18px] w-[18px]" />
        </button>
      </div>
      <FileManager closeFileManager={closeDialog} />
    </>
  );
};
